
import { CbxVariablesModule } from "@/store/modules/CbxVariablesModule";
import { Component, Prop, Vue } from "vue-property-decorator";
import SignUpForm from "./SignUpForm.vue";
import { NewCustomerConfig } from "@/models/CbxVariables";

@Component({
    name: "SignUpOverlay",
    components: {
        SignUpForm,
    }
})

export default class SignUpOverlay extends Vue {
    @Prop({ type: String, required: false, default: "default" }) type: string;

    open: boolean = false;

    get translationsReady(): boolean {
        return this.$root.$data.translationsLoaded === true;
    }

    get enabled(): boolean {
        return this.config?.enabled;
    }

    get config(): NewCustomerConfig {
        return CbxVariablesModule.VARIABLES.newCustomerConfig;
    }

    show() {
        this.open = true;
    }

    hide() {
        this.open = false;
    }
}
